export enum DraggableItemType {
  PageConfigWidget,
  SkinnyBannerWidget,
}

export type DraggableItemTypes = typeof DraggableItemType[keyof typeof DraggableItemType];
